export default {
  'tours.heroEyebrow': 'Khám phá Việt Nam',
  'tours.heroTitle': 'Tour Trọn Gói',
  'tours.heroSubtitle': 'Những hành trình khắp Việt Nam được chăm chút tỉ mỉ, từ miền Bắc sương mù đến miền Nam nắng ấm — nói cho chúng tôi biết nơi bạn muốn đến, chúng tôi sẽ cùng bạn kiến tạo nên chuyến đi tuyệt vời nhất.',
  'tours.breadcrumbHome': 'Trang chủ',
  'tours.gridTitle': 'Tour trọn gói',
  'tours.searchPlaceholder': 'Tìm kiếm theo tên tour',
  'tours.styleAll': 'Phong cách của bạn: Tất cả',
  'tours.styleMobileAll': 'Phong cách: Tất cả',
  'tours.styleMultiDay': 'Nhiều ngày',
  'tours.styleDayTour': 'Tour trong ngày',
  'tours.styleCruise': 'Du thuyền',
  'tours.durationAll': 'Thời lượng: Tất cả',
  'tours.days1to3': '1-3 ngày',
  'tours.days4to7': '4-7 ngày',
  'tours.days8plus': '8+ ngày',
  'tours.noMatch': 'Không tìm thấy tour phù hợp với bộ lọc. Hãy thử điều chỉnh lại tìm kiếm nhé.',
  'tours.spots': '{{count}} điểm đến',
  'tours.from': 'Từ',
  'tours.view': 'Xem',
  'tours.addWishlist': 'Thêm vào yêu thích',
  'tours.prevPage': 'Trang trước',
  'tours.nextPage': 'Trang sau',
  'tours.pagination': 'Phân trang',
  'destinations.title': 'Đâu là điểm đến yêu thích của bạn?',
  'destinations.error': 'Không thể tải danh sách điểm đến.',
  'destinations.tryAgain': 'Thử lại',
  'intro.text': 'Việt Nam đang nhanh chóng trở thành điểm đến được yêu thích nhất Đông Nam Á, chinh phục trái tim của mọi du khách. Dù bạn khao khát những chuyến phiêu lưu mạo hiểm, muốn khám phá nền văn hóa đặc sắc, thưởng thức nền ẩm thực đẳng cấp thế giới, hay đơn giản là tận hưởng kỳ nghỉ dưỡng sang trọng bậc nhất — Việt Nam đều có một hành trình được thiết kế riêng, vừa vặn với chính bạn.',
  'faq.title': 'Câu hỏi thường gặp',
  'faq.error': 'Không thể tải câu hỏi thường gặp.',
  'faq.tryAgain': 'Thử lại',
  'carousel.howEarn': 'Vì sao chúng tôi đạt được',
  'carousel.star': '4.9 sao',
  'carousel.on': 'trên',
  'carousel.error': 'Không thể tải đánh giá.',
  'carousel.tryAgain': 'Thử lại',
  'carousel.showLess': 'Thu gọn',
  'carousel.readMore': 'Đọc thêm',
  'carousel.postedOn': 'Đăng trên',
  'carousel.prev': 'Đánh giá trước',
  'carousel.next': 'Đánh giá sau',
  'tours.heroAlt': 'Tour trọn gói - Khám phá Việt Nam',
  'intro.videoTitle': 'Video giới thiệu về Việt Nam',
};